import { IotProtocolType } from '../../types';
import FormItem from './estun/FormItems';
import { ComponentType } from 'react';

export const alarmIotProtocolFormItemsByType: Partial<Record<IotProtocolType, ComponentType>> = {
  [IotProtocolType.ESTUN]: FormItem,
};
